export const PERSONALIZATION = {
  COMPANY: 'company',
  INDIVIDUAL: 'individual'
}
